import { render, staticRenderFns } from "./CreateRuche.vue?vue&type=template&id=8081668c&"
import script from "./CreateRuche.vue?vue&type=script&lang=js&"
export * from "./CreateRuche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports